import { createActionConst } from '../../../utils/action.utils';

const KPI_PAGE_NAMESPACE = 'KPI_PAGE';

export const INITIAL_KPI_PAGE = createActionConst(KPI_PAGE_NAMESPACE, 'INITIAL_KPI_PAGE');
